import { SITE_CONFIG } from "@/constants";

/**
 * Absolute URL on the public site. `SITE_CONFIG.url` ends with a slash, so
 * plain concatenation produced `https://…online//formations`.
 */
export function absoluteUrl(path: string): string {
  return new URL(path, SITE_CONFIG.url).toString();
}

/**
 * Body of an inline `<script type="application/ld+json">`. `<` is escaped so
 * admin-written text (FAQ answers, labels) can never close the script tag.
 */
export function serializeJsonLd(data: unknown): string {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}
